import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CoverageDisplayEnum } from '@app/core/enums/coverage-display.enum';
import {
    CoverageMergeOptionsInterface,
    CoverageRemoveOptionsInterface,
} from '@app/core/interfaces';
import { CoverageTransformBuilder } from '@app/my-zone/builders/coverage-transform.builder';
import { coverageMergeOptionsConfig } from '@app/my-zone/config/coverage-merge-options.config';
import { coverageOrderOptionsConfig } from '@app/my-zone/config/coverage-order-options.config';
import { coverageRemoveOptionsConfig } from '@app/my-zone/config/coverage-remove-options.config';
import { CoverageSpecificationInterface, PurchasedProductInterface } from 'outshared-lib';

@Component({
    selector: 'ins-insurance-list-coverages',
    templateUrl: 'insurance-list-coverages.component.html',
})
export class InsuranceListCoveragesComponent implements OnChanges {

    @Input() public purchasedProduct!: PurchasedProductInterface;
    @Input() public display!: CoverageDisplayEnum;

    public coverages: CoverageSpecificationInterface[] = [];

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.purchasedProduct) {
            this.setCoverages(changes.purchasedProduct.currentValue);
        }
    }

    private setCoverages(purchasedProduct: PurchasedProductInterface): void {
        this.coverages = this.createCoverageList(
            purchasedProduct,
            this.display,
        );
    }

    private createCoverageList(
        purchasedProduct: PurchasedProductInterface,
        display: CoverageDisplayEnum,
    ): CoverageSpecificationInterface[] {
        const { productId, coverage } = purchasedProduct;
        const toRemove: CoverageRemoveOptionsInterface = coverageRemoveOptionsConfig[productId];
        const toMerge: CoverageMergeOptionsInterface = coverageMergeOptionsConfig[productId];
        const order: { [id: string]: number } = coverageOrderOptionsConfig[productId];
        const coverages = new CoverageTransformBuilder([ ...coverage.baseCoverages, ...coverage.additionalCoverages ])
            .filterByDisplay(display)
            .filterUnnecessary()
            .remove(toRemove)
            .merge(toMerge)
            .order(order)
            .build();

        return coverages;
    }
}
